import { render, staticRenderFns } from "./add-banji-dialog.vue?vue&type=template&id=e7720c44&"
import script from "./add-banji-dialog.vue?vue&type=script&lang=ts&"
export * from "./add-banji-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./add-banji-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports